import { render, staticRenderFns } from "./HeadlineRelatedTitle.vue?vue&type=template&id=58ca7084"
import script from "./HeadlineRelatedTitle.vue?vue&type=script&lang=ts"
export * from "./HeadlineRelatedTitle.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineRelatedTitle.vue?vue&type=style&index=0&id=58ca7084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports